import { render, staticRenderFns } from "./pipetteHome.vue?vue&type=template&id=87a9f460&scoped=true&"
import script from "./pipetteHome.vue?vue&type=script&lang=js&"
export * from "./pipetteHome.vue?vue&type=script&lang=js&"
import style0 from "./pipetteHome.vue?vue&type=style&index=0&id=87a9f460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a9f460",
  null
  
)

export default component.exports